import { HttpErrorResponse } from "@angular/common/http";
import { RedirectCommand, Router, RouterStateSnapshot } from "@angular/router";
import { Observable, OperatorFunction, of } from "rxjs";
import { catchError } from "rxjs/operators";

const notFoundStatuses = [403, 404];

/**
 * Resolver error handler: a missing or inaccessible record redirects to the not-found page naming
 * the element, keeping the requested url in the address bar so Back and reload still work.
 * Any other error resolves to null, as before.
 */
export function notFoundOr<T>(
  element: string,
  router: Router,
  state: RouterStateSnapshot,
): OperatorFunction<T, T | RedirectCommand> {
  return catchError((error: unknown): Observable<RedirectCommand | null> =>
    of(
      error instanceof HttpErrorResponse &&
        notFoundStatuses.includes(error.status)
        ? new RedirectCommand(router.parseUrl("/not-found"), {
            browserUrl: state.url,
            state: { element },
          })
        : null,
    ),
  );
}
